module.exports = __webpack_public_path__ + "img/arbol2000.7b2ace07.png";